<div 
    class="chapter" 
    [ngClass]="{ 'chapter--selected': selected }">
    
    <div class="chapter__thumb" [ngStyle]="getChapterThumb(chapter.id)"></div>

    <div class="chapter__title">
      <div class="chapter__number">{{ index + 1 }}.</div><div class="pr-1">{{ chapter.info.displayName }}</div>
    </div>
    
  </div>